import React from 'react';
import './AnnouncementBanner.css';
// Placeholder video path; replace with actual video
import festivalVideo from '../content/videos/NocturnalFestVideo.mp4';
// Logo
import NocLogo from '../content/Noc-icon.png';

function AnnouncementBanner() {
  return (
    <section className="announcement-banner" aria-label="Nocturnal Festival 2025 announcement">
      <div className="banner-marquee banner-marquee-top">
        <span></span>
      </div>
      <video className="banner-video" autoPlay loop muted playsInline>
        <source src={festivalVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="banner-content">
        {/* <img src={NocLogo} alt="CRP Noctem Logo" className="banner-logo" /> */}
        <a href='https://www.howler.co.za/nocturnalfestival' className='ticket-button'>TICKETS</a>
      </div>
      <div className="banner-marquee banner-marquee-bottom">
        <span>• 2025 CRP • NOCTURNAL FESTIVAL • DECEMBER • 2025 CRP • NOCTURNAL FESTIVAL • DECEMBER •</span>
      </div>
    </section>
  );
}

export default AnnouncementBanner;